export const THEME = {
  white: `background-color: var(--white) !important;
     color: var(--gray-60) !important;
     border: 1px solid var(--gray-30) !important;
    `,
  sky: `background-color: var(--primary-5) !important;
     color: var(--primary-60) !important;
     border: 1px solid var(--primary-30) !important;
    `,
  blue: `background-color: var(--primary-50) !important;
     color: var(--white) !important;
    `,
  gray: `background-color: var(--gray-5) !important;
     color: var(--gray-60) !important;
     border: 1px solid var(--gray-50) !important;
    `,
};
